var _rect, _path, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKindestLogo = function SvgKindestLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.25854,
    height: 35.9993,
    fill: "#2F2F4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11102 21.8477L19.2653 36.0008H30.991L16.8367 21.8477H5.11102Z",
    fill: "#2F2F4B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.68001,
    height: 10.8626,
    transform: "matrix(0.706269 -0.706271 0.706269 0.706271 16.6628 14.9316)",
    fill: "#2F2F4B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2331,
    y: 10.2695,
    width: 6.6721,
    height: 10.7715,
    transform: "rotate(45 27.2331 10.2695)",
    fill: "#2F2F4B"
  })));
};
export default SvgKindestLogo;